import { render } from "./maternity_treatment.vue?vue&type=template&id=12031888&scoped=true"
import script from "./maternity_treatment.vue?vue&type=script&lang=js"
export * from "./maternity_treatment.vue?vue&type=script&lang=js"

import "./maternity_treatment.vue?vue&type=style&index=0&id=12031888&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12031888"]])

export default __exports__